import PropTypes from 'prop-types';
import React from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import Utils from "./ClockUtils";
import { Modal, message, Spin } from "antd";
import { hashHistory, Link } from 'react-router';

export default class ClockIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired, // this is passed from the Rails div
  };

  /**
   * @param props - Comes from your rails div.
   */
  constructor(props) {
    super(props);
    let role = CurrentRoleStore.getCurrentRole();
    this.state = {
      classId: props.classId ? props.classId : props.location.query.classId,
      role,
      tasks: [],
      completedTasks: [],
      visible: false,
      loading: false
    };
  }

  componentDidMount() {
    this.getDailyAttendanceTasks();
  }

  getDailyAttendanceTasks() {
    this.setState({
      loading: true
    })
    let classId = this.state.classId ? this.state.classId : (this.state.role.associatName == 'classRecord' ? this.state.role.associatObj.id : this.state.role.associatObj.classId);
    let data = {
      class_record_id: classId
    }
    DataService.getDailyAttendanceTasks(data).then((res) => {
      this.setState({
        tasks: res.filter(task => !task.is_completed),
        completedTasks: res.filter(task => task.is_completed),
        loading: false
      })
    }).catch((error) => {
      console.log(error);
      this.setState({
        loading: false
      })
    });

  }

  editTask(e, item) {
    e.stopPropagation();
    if (item.is_completed)  {
      Modal.confirm({
        title: '删除打卡',
        content: '删除后该历史打卡成果将会被删除，无法在回顾打卡内容',
        onOk: () =>{
          DataService.destroyTask(item.id).then((res) => {
            message.success('删除成功！');
            this.getDailyAttendanceTasks();
          }).catch((error) => {
            message.error('删除失败！')
          });
        },
        onCancel() {
          console.log('Cancel');
        },
      });      
    } else {
      Modal.confirm({
        title: '结束打卡',
        content: '本打卡将于今日24点结束，明天起不能继续打卡',
        onOk:() => {
          DataService.completeTask(item.id).then((res) => {
            message.success('打卡将于今日24点结束！');
            this.getDailyAttendanceTasks();
          }).catch((error) => {
            message.error('操作失败！')
          });
        },
        onCancel() {
          console.log('Cancel');
        },
      });      
    }
  }

  goClockDetail(item, e) {
    e.stopPropagation();
    if (this.props.activeKey) {
      localStorage.setItem('tabKey', this.props.activeKey)
    }
    hashHistory.push(`clock-in/tasks/${item.id}`);
  }

  viewFile(e, file) {
    e.stopPropagation();
    this.setState({
      visible: true,
      file
    })
  }

  onCancelModal() {
    this.setState({
      visible: false,
    })
  }

  _taskItemView(item) {
    return (
      <div className="card-item" onClick={(e) => this.goClockDetail(item, e)} key={item.id}>
        <div className="item-header">
          <div>{item.title}</div>
          {item.is_completed || !item.close_at ? <div className="bullets-box" onClick={(e) => this.editTask(e, item)}>
            <a>{item.is_completed ? '删除打卡' : '结束打卡'}</a>
          </div> : ''}
        </div>
        <pre className="item-content">{item.description}</pre>
        <div className="img-container">
          {item.upload_files.map(file =>
            <div className="img-box" key={file.id} onClick={(e) => this.viewFile(e, file)}>
              <img className="img" src={Utils.getSmallMedia(file.remote_url, file.file_type)}>
              </img>
            </div>
          )}
        </div>
        <div className="item-info-list">
          <div className="info-detail">
            <div className="info-title">打卡频率</div>
            <div className="info-label">{Utils.toolsFrequency(item.frequency_info)}</div>
          </div>
          <div className="info-detail">
            <div className="info-title">参与人员</div>
            <div className="info-label">{item.student_ids_info && item.student_ids_info.length > 0 ? '学生' + item.student_ids_info.length + '人' : '全班'}</div>
          </div>
          <div className="info-detail">
            <div className="info-title">打卡进度</div>
            {item.is_completed ? <div className="info-label">打卡已结束</div> : <div className="info-label">{item.close_at ? '今日24点结束' : ('已进行' + item.current_day_index + '/' + item.days_count + '天')}</div>}
          </div>
        </div >
      </div >
    )
  }

  _imageViewModal() {
    let file = this.state.file;
    return (
      <div className="image-view-modal">
        <div className="image-view-modal-mask" onClick={() => this.onCancelModal()}></div>
        <div className="photos-wrapper">
          <div className="face-recognition-photos-view">
            <span className="photo-view-span">
              {file.file_type == 'photo' ? <img src={file.remote_url} className="photo-card-img" /> : <video controls src={file.remote_url} className="photo-card-img" ></video>}
            </span>
          </div>
          <div className="image-view-modal-cancel" onClick={() => this.onCancelModal()} ></div>
        </div>
      </div>
    )
  }
  
  render() {
    let { tasks, completedTasks, visible, loading } = this.state;
    return (
      <Spin tip="加载中..." spinning={loading}>
        <div className="clock-index-page">
          <div className="card-list">
            {tasks.length > 0 ? <div className="card-label">正在进行中的打卡</div> : ''}
            {tasks.map(item => this._taskItemView(item))}
            {completedTasks.length > 0 ? <div className="card-label">已结束的打卡</div> : ''}
            {completedTasks.map(item => this._taskItemView(item))}
          </div >
          {/* <div className="card-list">
          </div > */}
          {tasks.length <= 0 && completedTasks.length <= 0 ? <div className="no-message-box">
            <div className="no-message">暂无打卡任务~</div>
          </div> : ''}
          {visible ? this._imageViewModal() : ''}
        </div >
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/clock/ClockIndexPage.jsx